import React, { useEffect, useState } from 'react';
import { Grid } from '@material-ui/core'
import { SelectWithLabel } from '../../../../utils/selectWithLabel';
import { factChoices } from "./etc";
import _ from 'lodash';

const getApfaxArr = (pax) => {
  let apfaxChoices = factChoices.map(fact => fact.value)
  let outputArr = []

  for (let i = 0; i < apfaxChoices.length; i++) {
    const fact = apfaxChoices[i];
    if (pax[fact] === "1") {
      outputArr.push(fact)
    }
  }

  return outputArr
}

const ApfaxEdit = (props) => {
  const modalClasses = props.modalClasses
  const pax = props.pax
  const flight = props.flight
  const changeData = props.changeData
  const [selectedRloc, setRloc] = useState('')
  // TODO // can we send multiple facts?
  const [fact, setFact] = useState('')

  const resetFact = () => {
    setFact('')
    changeData('', 'apfax')
  }

  // NOTE // on changing the selected passenger, or closing and opening the edit tab, revert the data if an rloc wasn't selected
  useEffect(() => {
    if (!selectedRloc) {
      resetFact()
    }
  }, [pax]);

  const getRlocChoices = (paxArr) => {
    let rlocChoices = [{label: 'None', value: ''}]
    let rlocs = paxArr.map((pax) => {
      if (pax.PNRRefNo) {
        return {label: `${pax.PNRRefNo}`, value: `${pax.PNRRefNo}`}
      }
    })
    let uniqueRlocs = _.uniqBy(rlocs, 'value')
  
    return rlocChoices.concat(uniqueRlocs)
  }

  const rlocChoices = getRlocChoices(flight.passengers)

  let paxFacts = getApfaxArr(pax)
  // NOTE // no point in adding a fact twice, so filter out facts that the pax already has
  const filteredFactChoices = _.clone(factChoices).filter(fact => !paxFacts.includes(fact.value))

  // NOTE // this is a lot more convoluted than it should've been. setRloc/setFact don't seem to work synchronously
  const formatFormData = (data, type) => {
    let rloc = selectedRloc ? selectedRloc : (type === 'rloc' ? data : '')
    let editData
    // NOTE // if an rloc is selected, that takes precedence over a passenger being chosen
    if (!!selectedRloc || (type === 'rloc' && data)) {
      editData = {fact: fact, flightNumber: flight.FlightNumber, origin: flight.Origin, destination: flight.Destination}
    }
    else {
      editData = {fact: data, flightNumber: pax.FLTNO, paxNumber: pax.PaxNumber, origin: pax.ORIGIN, destination: pax.DESTIN}
    }
    // Requires {editData: {fact, flight number, pax number, origin, destination}, rloc, type, airlineId} (pax number is optional)
    // NOTE // if choice for rloc or fact was None (None has a value of '')
    if (!data) {
      if (type === 'rloc') {
        editData = pax ? {fact: fact, flightNumber: pax.FLTNO, paxNumber: pax.PaxNumber, origin: pax.ORIGIN, destination: pax.DESTIN} : ''
        pax ? changeData({editData: editData, rloc: pax.PNRRefNo, type: 'addApfax', airlineId: ''}, 'apfax') : changeData('', 'apfax')
      }
      else {
        changeData('', 'apfax')
      }
    }
    else {
      changeData({editData: editData, rloc: (rloc ? rloc : pax.PNRRefNo), type: 'addApfax', airlineId: ''}, 'apfax')
    }
  }

  const handleChange = (data, type) => {
    // NOTE // set the data from the form
    if (type === 'rloc') {
      setRloc(data)
    }
    else {
      setFact(data)
    }

    // NOTE // if a fact and pax/rloc are chosen, format the data
    if ((!!fact || type === 'fact') && (!!selectedRloc || !!pax || type === 'rloc')) {
      formatFormData(data, type)
    }
  }

  return (
    <div>
      <Grid id="process-explanation" container justifyContent="center" item xs={12}>
        <Grid container justifyContent="center" item xs={11} className={modalClasses.instructionText}>
          <span>For adding an apfax, choose a fact to add. If an rloc is selected, saving </span>
          <span>changes will add the chosen fact to all passengers that share the record locator</span>
        </Grid>
      </Grid>
      <Grid id="form-options" container justifyContent="center" item xs={12}>
        <Grid container justifyContent="center" item xs={4} lg={4}>
          <SelectWithLabel defaultVal={fact} handleChange={(e) => {handleChange(e.target.value, 'fact')}} inputLabel={'Fact'} items={filteredFactChoices} customStyle={{width: '90%'}} />
        </Grid>
        <Grid container justifyContent="center" item xs={4} lg={4}>
          <SelectWithLabel defaultVal={selectedRloc} handleChange={(e) => {handleChange(e.target.value, 'rloc')}} inputLabel={'RLOC'} items={rlocChoices} customStyle={{width: '90%'}} />
        </Grid>
      </Grid>
    </div>
  )
}

export default ApfaxEdit